import { Nullable } from '@shared/models/types/primary'
import {
  MEDIA_DEVICE_MISSING_ERRORS,
  MEDIA_IN_USE_ERRORS,
  MEDIA_PERMISSION_ERRORS,
} from '@shared/utils/constants/errors/media-errors'
import { getErrorName } from '@shared/utils/helpers/error-guards/error-guards'

export type MediaErrorType =
  | 'mediaPermissionDenied'
  | 'mediaDeviceInUse'
  | 'mediaDeviceMissing'

export const isMediaPermissionError = (error: unknown) =>
  MEDIA_PERMISSION_ERRORS.includes(getErrorName(error))

export const isMediaInUseError = (error: unknown) =>
  MEDIA_IN_USE_ERRORS.includes(getErrorName(error))

export const isMediaDeviceMissingError = (error: unknown) =>
  MEDIA_DEVICE_MISSING_ERRORS.includes(getErrorName(error))

export const isMediaError = (error: unknown) =>
  isMediaPermissionError(error) ||
  isMediaInUseError(error) ||
  isMediaDeviceMissingError(error)

export const getMediaErrorType = (error: unknown): Nullable<MediaErrorType> => {
  if (!isMediaError(error)) {
    return null
  }

  if (isMediaPermissionError(error)) {
    return 'mediaPermissionDenied'
  }

  if (isMediaInUseError(error)) {
    return 'mediaDeviceInUse'
  }

  if (isMediaDeviceMissingError(error)) {
    return 'mediaDeviceMissing'
  }

  return null
}
